import React, { useState, useRef, useEffect } from 'react';
import { Marker } from "react-simple-maps";

import AnimatedLine from './AnimatedLine';
import AnimatedMarker from './AnimatedMarker';


export default function AnimatedRouteSegment({ location, lastLocationCoords, onFinished, zoom, color }) {
  const [state,setState] = useState("placeholder");
  const [lineEndCoords,setLineEndCoords] = useState();
  const placeholderRef = useRef();
  const markerRadius = 10/zoom;

  useEffect( () => {
    switch(state) {
      case 'placeholder':
        setLineEndCoords( getCoords( placeholderRef.current.parentElement ) );
        setState( lastLocationCoords ? "line" : "marker" );
        break;
      default:
    }
  }, [state, lastLocationCoords] );

  const onLineDrawEnd = () => setState("marker");
  const onMarkerDrawEnd = () => onFinished(lineEndCoords);

  if( state === 'placeholder' ) {
    return (
      <Marker coordinates={[location.longitude,location.latitude]}>
        <circle r={markerRadius} fill="#00000000" ref={placeholderRef} />
      </Marker>
    );
  }
  else {
    return <>
      { (lastLocationCoords && lineEndCoords) && (
        <AnimatedLine
          from={lastLocationCoords}
          to={lineEndCoords}
          zoom={zoom}
          strokeWidth={markerRadius/2}
          markerRadius={markerRadius}
          color={color}
          onAnimationEnd={onLineDrawEnd}
        />
      )}
      { (state !== "line") && (
        <AnimatedMarker location={location} radius={markerRadius} color={color} onAnimationEnd={onMarkerDrawEnd} />
      )}
    </>;
  }
}

function getCoords(element) {
  let coords;
  try {
    // Per MDN: "e and f represent the translation amounts" (react-simple-maps uses translation for positioning)
    const { e, f } = element.transform.baseVal.consolidate().matrix;
    coords = [e,f];
  } catch(e) {
    console.error("Marker out of bounds");
  }
  return coords;
}
